import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { blogPosts } from '../../mocks/blogs';

export default function BlogsPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* 面包屑導航 */}
      <div className="bg-gray-50 py-4 mt-32">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-gray-900">首頁</Link>
            <span>/</span>
            <span className="text-gray-900">童裝資訊</span>
          </div>
        </div>
      </div>

      {/* 頁面標題 */}
      <div className="max-w-7xl mx-auto px-4 py-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">童裝資訊</h1>
        <p className="text-lg text-gray-600">探索最新的中國童裝流行趨勢、穿搭技巧和育兒知識</p>
      </div>

      {/* 博客列表 */}
      <div className="max-w-7xl mx-auto px-4 pb-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post) => (
            <Link
              key={post.id}
              to={`/blogs/${post.slug}`}
              className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              {/* 文章圖片 */}
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={post.image}
                  alt={post.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-black/80 text-white px-3 py-1 rounded-full text-sm whitespace-nowrap">
                    {post.category}
                  </span>
                </div>
              </div>

              {/* 文章內容 */}
              <div className="p-6">
                <div className="flex items-center gap-2 text-sm text-gray-500 mb-3">
                  <i className="ri-calendar-line"></i>
                  <span>{post.date}</span>
                </div>

                <h2 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-pink-600 transition-colors line-clamp-2">
                  {post.title}
                </h2>

                <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-3">
                  {post.excerpt}
                </p>

                {/* 標籤 */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {post.tags.map((tag, index) => (
                    <span
                      key={index}
                      className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded"
                    >
                      #{tag}
                    </span>
                  ))}
                </div>

                {/* 閱讀更多 */}
                <div className="flex items-center gap-2 text-pink-600 font-medium text-sm group-hover:gap-3 transition-all">
                  <span>閱讀更多</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
